import React from "react";
import methodModel from "../../../methods/methods";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { Listbox } from "@headlessui/react";
import { colourStyles } from "../../../utils/constants";
import { IoIosArrowDown } from "react-icons/io";
import { FiCheck } from "react-icons/fi";

const Html = ({
  options,
  sort,
  showPlaceHolder,
  selectedValues,
  handleChange,
  showCross,
  displayValue = "name",
  id,
  noOptionsMessage = "No Option Available",
  placeholder,
  required,
  disabled,
  name,
  noDefault,
  className = "",
  theme = "normal",
  dynamicStyle,
  crossIcon,
  noCapitalize = false,
  placeholderCap,
  isLoading = false,
  creatable = false,
  addNewOption = async () => {},
  isFocusedData,
}) => {
  const categoryVal = () => {
    let ext = options && options.find((item) => item.id == selectedValues);
    return ext ? { value: ext.id, label: ext[displayValue] } : "";
  };

  const handleSelectChange = (val) => {
    const finalVal = typeof val === "object" && val !== null ? val.id : val;
    handleChange(finalVal);
  };

  const sortedOptions = options || [];

  const handleCreate = async (inputValue) => {
    try {
      const newOption = await addNewOption(inputValue);
      if (newOption && newOption.id) {
        handleChange(newOption.id);
      }
    } catch (error) {}
  };

  const getEnhancedColourStyles = (isFocusedData) => ({
    ...colourStyles,
    control: (styles, props) =>
      colourStyles.control(styles, { ...props, isFocusedData }),
    option: (provided, state) => ({
      ...colourStyles.option(provided, state),
    }),
  });

  return (
    <>
      <div
        className={`selectDropdown ${className} ${disabled ? "disabledDropdown" : ""}`}
      >
        {theme === "search" || creatable ? (
          <>
            {creatable ? (
              <CreatableSelect
                styles={{
                  ...getEnhancedColourStyles(isFocusedData),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={document.body}
                options={
                  sortedOptions?.map((itm) => ({
                    value: itm.id,
                    label: itm[displayValue],
                    imageUrl: itm.imageUrl,
                  })) || []
                }
                placeholder={placeholder}
                isFocusedData={isFocusedData}
                value={categoryVal()}
                // isClearable={crossIcon}
                menuPlacement="auto"
                isDisabled={disabled}
                name={name}
                required={required}
                isLoading={isLoading}
                onChange={(e) => handleChange(e?.value || "")}
                onCreateOption={handleCreate}
                classNamePrefix="react-select"
                // menuIsOpen={true}
                className={`rounded-[0.75rem] !outline-none ring-0 focus:!outline-none focus:ring-0`}
              />
            ) : (
              <Select
                styles={{
                  ...getEnhancedColourStyles(isFocusedData),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                options={
                  sortedOptions?.map((itm) => ({
                    value: itm.id,
                    label: itm[displayValue],
                    imageUrl: itm.imageUrl,
                  })) || []
                }
                menuPortalTarget={document.body}
                placeholder={placeholder}
                value={categoryVal()}
                // isClearable={crossIcon}
                isDisabled={disabled}
                name={name}
                required={required}
                noOptionsMessage={() => noOptionsMessage}
                isLoading={isLoading}
                menuPlacement="auto"
                onChange={(e) => handleChange(e?.value || "")}
                classNamePrefix="react-select"
                // menuIsOpen={true}
                className={`rounded-[0.75rem] !outline-none ring-0 focus:!outline-none focus:ring-0`}
              />
            )}
          </>
        ) : (
          <Listbox
            value={selectedValues}
            onChange={handleSelectChange}
            disabled={disabled}
          >
            <div className="list_box_active_state relative">
              <Listbox.Button
                className={`${noCapitalize ? "lowercase" : ""} relative outline-none focus:outline-none focus:ring-0 focus-visible:outline-none disabled:!bg-gray-200 ${className ? className : "w-full"}
                  flex items-center justify-between gap-1.5 cursor-pointer rounded-xl bg-white !px-3 text-left shadow-box border-[1.5px] border-slate-500 h-10`}
              >
                <span
                  className={`text-typo block text-sm font-normal truncate ${noCapitalize && selectedValues ? "lowercase" : ""}`}
                >
                  {selectedValues
                    ? methodModel.find(options, selectedValues, "id")?.[
                        displayValue
                      ] || placeholder
                    : placeholder}
                </span>
                <IoIosArrowDown className="h-[18px] w-5 text-[#75757A]" />
              </Listbox.Button>
              <Listbox.Options
                className={`${dynamicStyle ? "" : "max-h-60"} border border-slate-300 text-sm absolute z-50 min-w-full right-0 shadow-lg py-1 mt-1.5 overflow-auto bg-white rounded-xl focus:outline-none scrollbar`}
              >
                {noDefault || !showPlaceHolder ? null : (
                  <Listbox.Option
                    value={""}
                    className={({ active }) => {
                      const isChosen = !selectedValues || selectedValues === "";
                      return `relative cursor-pointer ${noCapitalize && !placeholderCap ? "" : "!capitalize"} select-none py-2.5 px-3.5 transition-colors ${
                        isChosen
                          ? "bg-blue-50 text-[#115B9D] font-bold"
                          : active
                            ? "bg-slate-100 text-slate-900 font-semibold"
                            : "text-slate-500 hover:bg-slate-100"
                      }`;
                    }}
                  >
                    <span className={`block font-medium`}>{placeholder}</span>
                  </Listbox.Option>
                )}
                {sortedOptions &&
                  sortedOptions.map((item, itemIdx) => (
                    <Listbox.Option
                      key={itemIdx}
                      disabled={item?.disabled ? true : false}
                      value={item.id}
                      className={({ active, selected }) => {
                        const isChosen =
                          selected ||
                          String(selectedValues) === String(item?.id) ||
                          String(selectedValues) === String(item?.value);
                        return `relative cursor-pointer ${noCapitalize ? "" : "capitalize"} select-none py-2.5 px-3.5 transition-colors 
                        ${item?.isDisabled ? "bg-slate-100 text-slate-400 cursor-not-allowed" : ""} 
                        ${
                          isChosen
                            ? "!bg-[#115B9D] !text-white font-bold"
                            : active
                              ? "bg-slate-100 text-slate-900 font-semibold"
                              : "text-slate-900 hover:bg-slate-100"
                        }`;
                      }}
                    >
                      {({ selected }) => {
                        const isChosen =
                          selected ||
                          String(selectedValues) === String(item?.id) ||
                          String(selectedValues) === String(item?.value);
                        return (
                          <div className="flex items-center justify-between gap-2">
                            <span
                              className={`block truncate ${isChosen ? "font-bold text-white" : "font-medium"}`}
                            >
                              {item[displayValue]}
                            </span>
                            {isChosen ? (
                              <FiCheck className="w-4 h-4 text-white shrink-0" />
                            ) : null}
                          </div>
                        );
                      }}
                    </Listbox.Option>
                  ))}
              </Listbox.Options>
            </div>
          </Listbox>
        )}
      </div>
    </>
  );
};
export default Html;
